import React from "react";
import { AppAbility } from "./ability";
import { SessionInfoType } from "store/reducers/configs/sessionInfo.api";

export interface AbilityData { user: SessionInfoType, moduleName: string }

export interface AbilityContext {
    ability: AppAbility
    abilityData: AbilityData | null
    setAbilityData: ( data: AbilityData | null ) => void
}

export const AbilityContext = React.createContext<AbilityContext>(undefined!)